import { getSchedule } from "routes/schedule/lib/get-schedule"

export function useModifiedSchedule(group, scheduleId) {
    group ??= ""
    const [tree, parent] = group.split("!")
    return getSchedule.useResults(tree ? `${parent}${tree}!${scheduleId}` : scheduleId)
}
